'use client';

import { SSIBlock } from '@components/ssi-block';

import { partials } from '@helpers/partials';

export function ByouReinsurance() {
    return <SSIBlock url={partials.MARKETING.FAI_PRESENTATION_BYOU} />;
}
